import React, { Component } from "react";
import { Modal, Button, Typography } from "@plum-xoxo/admin-dsm";

class ProformaInvoice extends Component {
  state = {
    modal: true,
  };

  componentWillMount() {
    this.setState(this.props);
  }

  handleModal = () => {
    this.setState({
      modal: false,
    });
    this.props.modalStatus ? this.props.modalStatus() : null;
  };

  render() {
    const {
      modal,
      header,
      body,
      subBody,
      subTitle,
      headerClass,
      headerTitle = "",
    } = this.state;
    const {
      buttonText,
      btnText2,
      classname,
      proformaBody,
      disableCross = true,
      topMargin = "mt-32",
      width = "400px",
    } = this.props;
    return (
      <Modal
        isOpen={modal}
        onClose={() => this.handleModal()}
        disableCloseButton={disableCross}
        className="addAdminModal"
        style={{ width: width, minWidth: width }}
      >
        <Typography.H2>{headerTitle}</Typography.H2>
        {header ? <h5 className="mb-3 text-break">{header}</h5> : null}
        {body ? (
          <Typography component="div" color="dark" shade="c200">
            {body}
          </Typography>
        ) : null}

        {subBody ? (
          <Typography color="dark" shade="c200">
            {subTitle}
            {subBody}
          </Typography>
        ) : (
          ""
        )}
        {proformaBody ? (
          <Typography
            component="div"
            color="dark"
            shade="c200"
            className="mt-12"
          >
            {proformaBody}
          </Typography>
        ) : null}
        <div className={`d-flex ${topMargin}`}>
          <div className="ml-auto">
            {btnText2 ? (
              <Button
                variant="plain"
                color="primary"
                onClick={() => {
                  this.handleModal();
                }}
              >
                {this.props.btnText2}
              </Button>
            ) : null}
            <Button
              color="primary"
              className="ml-16"
              onClick={() => {
                this.props.actionProformaHandler();
              }}
              disabled={this.props.proformaLoader}
              loading={this.props.proformaLoader}
            >
              {buttonText ? buttonText : "Generate"}
            </Button>
          </div>
        </div>
      </Modal>
    );
  }
}
export default ProformaInvoice;
